import fetch from '../utils/fetch';

const USER_BASE = process.env.USER_API;

const getUrl = (path) => `${USER_BASE}${path}`;

export default {
  /**
   * Get information about currently logged-in user.
   * @returns {Promise<Object>} User info.
   */
  async getInfo() {
    return fetch(getUrl('/info'));
  },

  /**
   * Get list of third party API keys for user by ID.
   * @param {number} userId - User ID.
   * @returns {Promise<Array>} List of API keys.
   */
  async getApiKeys(userId) {
    return fetch(getUrl(`/api-keys/${userId}`));
  },
};
